import React from "react";
import './color.css'

const Color = () => {
    return (
        <div>
            <div className="w-full h-screen bg-green-50 relative">
                <div style={{ filter: "blur(150px)" }} className="w-30% h-24 rounded-full bg-lime-300 absolute "></div>
                <div style={{ filter: "blur(150px)" }} className="w-30% h-24 rounded-full bg-green-300 absolute right-0  "></div>
                <div style={{ filter: "blur(150px)" }} className="w-30% h-48 rounded-full bg-sky-300 absolute bottom-0"></div>
                <div style={{ filter: "blur(150px)" }} className="w-30% h-48 rounded-full bg-amber-200 absolute bottom-12 right-12"></div>
                <h className="text-5xl">My name is shakil</h>
            </div>
            {/* <div className="w-full h-screen color">
                <h1 className="text-5xl">My name is shakil</h1>

                background-color: rgb(30, 58, 138);
                background-image: radial-gradient(at 0% 100%, rgb(187, 247, 208) 0, transparent 100%),
                radial-gradient(at 28% 0%, rgb(254, 240, 138) 0, transparent 40%),
                radial-gradient(at 67% 74%, rgb(254, 215, 170) 0, transparent 100%),
                radial-gradient(at 80% 0%, rgb(37, 99, 235) 0, transparent 27%);

            </div> */}
        </div>

    );
}
export default Color;